import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30f8eb36"
import script from "./distributedItcDetails.js?vue&type=script&lang=js&external"
export * from "./distributedItcDetails.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports